import { defineStore } from "pinia";
import {
  collection,
  query,
  getFirestore,
  getDocs,
  doc,
  setDoc,
  updateDoc
} from "firebase/firestore";

import { userUserStore } from "../stores/user";
import {
  CategoriaProductos,
  categoriaProductosConverter
} from "@fixeduy/restaurantestypes";

export const useProductosCategoriasStore = defineStore({
  id: "productosCategoria",
  persist: true,
  state: () => {
    return {
      _categorias: [] as CategoriaProductos[],
      _categoriasCuenta: 0 as number
    };
  },
  getters: {
    categorias(): CategoriaProductos[] {
      return this._categorias;
    },
    getUltimoCategoriaEdicion(): number {
      let mayorFechaUltimaEdicion = 0;
      this._categorias.map(r => {
        if (r.ultimaEdicion > mayorFechaUltimaEdicion) {
          mayorFechaUltimaEdicion = r.ultimaEdicion;
        }
      });
      return mayorFechaUltimaEdicion;
    }
  },
  actions: {
    async getCategoriasFromFirestore() {
      const db = getFirestore();
      const userStore = userUserStore();
      const empresaId = userStore.empresa?.id;
      if (!empresaId) {
        this._categorias = [];
        console.warn(
          "[productosCategorias] No hay empresa seleccionada al cargar categorías."
        );
        return;
      }

      // Importante: sin "/" final, para evitar referencias inválidas/silenciosas.
      const collectionRoute = `empresas/${empresaId}/categorias-productos`;
      try {
        const querySnapshot = await getDocs(
          query(collection(db, collectionRoute)).withConverter(
            categoriaProductosConverter
          )
        );

        // Reemplazar lista completa para evitar inconsistencias por caché/empresa.
        this._categorias = querySnapshot.docs.map(doc => doc.data());
      } catch (error) {
        console.error(
          "[productosCategorias] Error al cargar categorías desde Firestore:",
          error
        );
        this._categorias = [];
      }
    },
    addCategoriaToStore(categoria: CategoriaProductos) {
      // reviso que no exista
      for (var i = 0; i < this._categorias.length; i++) {
        if (this._categorias[i].id == categoria.id) {
          this._categorias[i] = categoria;
          return; // corto ejecucion de la funcion
        }
      }

      // lo inserto y ordeno
      this._categorias.push(categoria);
      // this._categorias.sort((a, b) =>
      //   b.nombreCompleto > a.nombreCompleto ? -1 : 1
      // );
    },
    getCategoriaById(id: string): CategoriaProductos | null {
      for (var i = 0; i < this._categorias.length; i++) {
        if (this._categorias[i].id == id) {
          return this._categorias[i];
        }
      }
      return null;
    },
    getCategoriaByUltimaEdicion(
      ultimaEdicion: number
    ): CategoriaProductos | null {
      for (var i = 0; i < this._categorias.length; i++) {
        if (this._categorias[i].ultimaEdicion == ultimaEdicion) {
          return this._categorias[i];
        }
      }

      return null;
    },
    async crearCategoria(categoria: CategoriaProductos): Promise<boolean> {
      const userStore = userUserStore();
      const empresaId = userStore.empresa?.id;
      if (!empresaId) return false;

      const db = getFirestore();
      const collectionRoute = `empresas/${empresaId}/categorias-productos`;
      const docRef = doc(collection(db, collectionRoute));

      const nueva: CategoriaProductos = {
        id: docRef.id,
        version: 1,
        codigo: categoria.codigo,
        nombre: categoria.nombre,
        activo: true,
        ultimaEdicion: categoria.ultimaEdicion
      };

      try {
        await setDoc(docRef, nueva);
        this.addCategoriaToStore(nueva);
        return true;
      } catch (error) {
        console.error("Error al crear categoría:", error);
        return false;
      }
    },
    async updateCategoria(categoria: CategoriaProductos): Promise<boolean> {
      const userStore = userUserStore();
      const empresaId = userStore.empresa?.id;
      if (!empresaId) return false;

      const existente = this.getCategoriaById(categoria.id);
      if (!existente) return false;

      const db = getFirestore();
      const collectionRoute = `empresas/${empresaId}/categorias-productos`;
      const docRef = doc(
        collection(db, collectionRoute),
        categoria.id
      ).withConverter(categoriaProductosConverter);

      try {
        await updateDoc(docRef, categoria);
        const idx = this._categorias.findIndex(c => c.id === categoria.id);
        if (idx !== -1) {
          this._categorias[idx] = { ...this._categorias[idx], ...categoria };
        }
        return true;
      } catch (error) {
        console.error("Error al actualizar categoría:", error);
        return false;
      }
    }
  }
});
